// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState {
  hasUnsavedChanges: boolean;
}

const initialState: FormState = {
  hasUnsavedChanges: false,
};

export const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
  },
});

export const { setHasUnsavedChanges } = formSlice.actions;

export default formSlice.reducer;
